import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import Box from 'features/Hotel/Box'
import { useState } from 'react'

import styles from './HostedMessaging.module.scss'

const HostedMessaging = ({ fullName, status, reEnableRegistery }) => {
  const [isDialogVisible, setDialogVisible] = useState()
  const [authorizingParty, setAuthorizingParty] = useState('')

  function handleSendAuthorizingParty() {
    setDialogVisible(false)
    reEnableRegistery({ HostMessagingAuthorizingPartyFullName: authorizingParty })
  }

  return (
    <div className={styles.wrapper}>
      <Box title="Hosted messaging">
        <div className={styles.container}>
          <button className={styles.editButton} onClick={() => setDialogVisible(true)}>
            Edit
          </button>
          <span
            style={{
              color: status === 'Enabled' ? '#66bb6a' : 'rgb(190 187 187)',
              fontWeight: 600
            }}
          >
            {status}
          </span>
          {fullName && <> with name {fullName}</>}
        </div>
      </Box>
      {isDialogVisible && (
        <ConfirmationDialog
          title="Set hosted messaging"
          negativeMessage="Cancel"
          positiveMessage="Enable hosted messaging"
          onReject={() => setDialogVisible(false)}
          onConfirm={handleSendAuthorizingParty}
          isButtonDisabled={authorizingParty.length < 2}
          theme="blacklist"
        >
          <TextInput
            className={styles.input}
            label="Full name of authorized party"
            value={authorizingParty}
            onChange={e => setAuthorizingParty(e.target.value)}
          />
        </ConfirmationDialog>
      )}
    </div>
  )
}

export default HostedMessaging
